/* Case builder for the 12-bottle offer.
 *
 * Reads its config from a <script type="application/json"> block rendered by
 * the section, checks the live cart via /cart.js, and lets the customer top up
 * to the threshold by preference (rosé / white / red / mixed) or per bottle.
 *
 * Only variants that appear in the configured collections count toward the
 * threshold, which is how large formats stay excluded without needing tags.
 */
(function () {
  'use strict';

  function money(n) {
    return n;
  }

  function init(root) {
    var id = root.getAttribute('data-cp');
    var cfgEl = document.getElementById('cp-data-' + id);
    var modal = document.getElementById('cb-' + id);
    var openBtn = root.querySelector('[data-cp-open]');
    if (!cfgEl || !modal || !openBtn) return;

    var cfg;
    try {
      cfg = JSON.parse(cfgEl.textContent);
    } catch (e) {
      return;
    }

    var groups = (cfg.groups || []).filter(function (g) {
      return g.items && g.items.length;
    });
    if (!groups.length) {
      openBtn.hidden = true;
      return;
    }

    var threshold = cfg.threshold || 12;
    var eligible = {};
    groups.forEach(function (g) {
      g.items.forEach(function (it) { eligible[it.vid] = true; });
    });

    var scroll = modal.querySelector('[data-cb-scroll]');
    var quick = modal.querySelector('[data-cb-quick]');
    var countEl = modal.querySelector('[data-cb-count]');
    var addBtn = modal.querySelector('[data-cb-add]');
    var exploreLink = modal.querySelector('[data-cb-explore]');

    var picked = {};   // vid -> qty
    var inCart = 0;
    var built = false;
    /* True when the cart already met the threshold at the moment the modal
       was opened — the offer is live, so there is nothing to build. */
    var preUnlocked = false;

    function selected() {
      var n = 0;
      for (var k in picked) n += picked[k];
      return n;
    }

    function refresh() {
      var sel = selected();
      var total = inCart + sel;
      var left = Math.max(0, threshold - total);

      /* Sync the steppers first, before any early return below, so reopening
         the modal never leaves stale quantities on screen. */
      modal.querySelectorAll('[data-vid]').forEach(function (row) {
        var out = row.querySelector('[data-qty]');
        if (out) out.textContent = picked[row.getAttribute('data-vid')] || 0;
      });

      /* Cart already qualified and nothing picked yet: point them at the shop
         rather than at a case they do not need to build. As soon as they do
         pick something, fall back to the normal add flow so they are not
         stuck with a selection they cannot submit. */
      if (preUnlocked && sel === 0) {
        countEl.innerHTML = '<strong>Offer is already activated in your cart</strong>';
        addBtn.hidden = true;
        if (exploreLink) exploreLink.hidden = false;
        return;
      }

      addBtn.hidden = false;
      if (exploreLink) exploreLink.hidden = true;

      countEl.innerHTML = left > 0
        ? '<span class="cb__dot">' + total + '</span> ' + (total === 1 ? 'bottle' : 'bottles') +
          ' &middot; ' + left + ' more to unlock ' + cfg.discount + '% off'
        : '<strong>Offer unlocked</strong> &middot; add to cart to continue';

      addBtn.disabled = sel === 0;
      addBtn.textContent = sel === 0
        ? 'Select bottles'
        : 'Add ' + sel + (sel === 1 ? ' bottle' : ' bottles');
    }

    /* Spread `n` bottles round-robin over `items` so a fill produces a
       balanced selection rather than 12 of the first wine. */
    function distribute(items, n) {
      if (!items.length || n <= 0) return;
      for (var i = 0; i < n; i++) {
        var it = items[i % items.length];
        picked[it.vid] = (picked[it.vid] || 0) + 1;
      }
    }

    function fill(groupKey) {
      picked = {};
      var left = Math.max(0, threshold - inCart);
      if (left <= 0) { refresh(); return; }

      if (groupKey === 'mixed') {
        var per = Math.floor(left / groups.length);
        var rem = left - per * groups.length;
        groups.forEach(function (g, i) {
          distribute(g.items, per + (i < rem ? 1 : 0));
        });
      } else {
        var g2 = groups.filter(function (g) { return g.key === groupKey; })[0];
        if (g2) distribute(g2.items, left);
      }
      refresh();
    }

    function build() {
      quick.innerHTML = '';
      scroll.innerHTML = '';

      groups.forEach(function (g) {
        var c = document.createElement('button');
        c.type = 'button';
        c.className = 'cb__chip';
        c.textContent = 'Fill with ' + g.label;
        c.addEventListener('click', function () { fill(g.key); });
        quick.appendChild(c);
      });

      if (groups.length > 1) {
        var mix = document.createElement('button');
        mix.type = 'button';
        mix.className = 'cb__chip';
        mix.textContent = 'Mixed case';
        mix.addEventListener('click', function () { fill('mixed'); });
        quick.appendChild(mix);
      }

      var clear = document.createElement('button');
      clear.type = 'button';
      clear.className = 'cb__chip';
      clear.textContent = 'Clear';
      clear.addEventListener('click', function () { picked = {}; refresh(); });
      quick.appendChild(clear);

      groups.forEach(function (g) {
        var h = document.createElement('p');
        h.className = 'cb__group-label';
        h.textContent = g.label;
        scroll.appendChild(h);

        g.items.forEach(function (it) {
          var row = document.createElement('div');
          row.className = 'cb__row';
          row.setAttribute('data-vid', it.vid);

          var thumb = it.img
            ? '<img class="cb__thumb" src="' + it.img + '" alt="" loading="lazy">'
            : '<span class="cb__thumb"></span>';

          row.innerHTML =
            thumb +
            '<span class="cb__name"></span>' +
            '<span class="cb__price"></span>' +
            '<span class="cb__step">' +
            '<button type="button" data-dec aria-label="Remove one">&minus;</button>' +
            '<span data-qty>0</span>' +
            '<button type="button" data-inc aria-label="Add one">+</button>' +
            '</span>';

          row.querySelector('.cb__name').textContent = it.title;
          row.querySelector('.cb__price').textContent = money(it.price);

          row.querySelector('[data-inc]').addEventListener('click', function () {
            picked[it.vid] = (picked[it.vid] || 0) + 1;
            refresh();
          });
          row.querySelector('[data-dec]').addEventListener('click', function () {
            picked[it.vid] = Math.max(0, (picked[it.vid] || 0) - 1);
            if (!picked[it.vid]) delete picked[it.vid];
            refresh();
          });

          scroll.appendChild(row);
        });
      });
    }

    function open() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      if (!built) { built = true; build(); }

      /* Open with nothing pre-selected — the quick-fill chips are the only
         thing that sets quantities automatically. */
      picked = {};
      preUnlocked = false;
      refresh();

      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          inCart = (cart.items || []).reduce(function (n, i) {
            return eligible[i.variant_id] ? n + i.quantity : n;
          }, 0);
        })
        .catch(function () { inCart = 0; })
        .then(function () {
          preUnlocked = inCart >= threshold;
          refresh();
        });
    }

    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', open);
    modal.addEventListener('click', function (e) {
      if (e.target === modal || (e.target.closest && e.target.closest('[data-cb-close]'))) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });

    addBtn.addEventListener('click', function () {
      var items = Object.keys(picked).map(function (vid) {
        return { id: Number(vid), quantity: picked[vid] };
      });
      if (!items.length) return;

      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          /* cart-icon.js mirrors the bubble count in sessionStorage, and on the
             next load its ensureCartBubbleIsCorrect() will overwrite the freshly
             server-rendered count with that copy if it is under 10s old. We add
             via /cart/add.js without firing the theme's cartUpdate event, so the
             copy is stale — clear it and let the server-rendered count stand.
             Note we cannot just write our own total here: `inCart` counts only
             eligible variants, so it is not the cart's item_count. */
          try {
            sessionStorage.removeItem('cart-count');
          } catch (e) {
            /* sessionStorage can throw in private mode */
          }
          window.location.href = '/cart';
        })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = 'Try again';
        });
    });
  }

  function boot() {
    document.querySelectorAll('[data-cp]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
